export default __webpack_public_path__ + "static/media/staffing_firms.f2fa7eb1.svg";